import { render, staticRenderFns } from "./QuillEditorBubble.vue?vue&type=template&id=b0ab92d4&"
import script from "./QuillEditorBubble.vue?vue&type=script&lang=js&"
export * from "./QuillEditorBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports